module.exports = __webpack_public_path__ + "static/media/16UNODC9.84214ee1.jpg";